import * as ActionTypes from '../constants/ActionTypes';

export const setReport = (data) => {
  return {
    type: ActionTypes.SET_REPORT,
    payload: data
  };
};
